export const SELLING_PLANS = {
  DAY_7: "690060558676",
  DAY_14: "690060525908",
  DAY_28: "690060591444",
} as const;

export type SellingPlanKey = keyof typeof SELLING_PLANS;
